import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';
import { resolveInternalPath } from '@/lib/ai-assistant/resolveInternalPath';

// Assistant replies: markdown without raw HTML. App links go through the
// router (the panel stays open); anything else opens in a new tab. Images
// only render from https URLs (e.g. a clip preview frame).
export function AssistantMarkdown({ text }: { text: string }) {
  return (
    <div className="assistant-markdown space-y-2 break-words text-sm leading-relaxed [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:my-0.5 [&_strong]:font-semibold [&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:text-xs">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        components={{
          a: ({ href, children }) => {
            const internal = resolveInternalPath(href, [window.location.origin, 'https://app.autoclipper.live']);
            if (internal) {
              return (
                <Link to={internal} className="font-medium text-primary underline underline-offset-2">
                  {children}
                </Link>
              );
            }
            const safe = typeof href === 'string' && /^https?:\/\//.test(href) ? href : undefined;
            return safe ? (
              <a
                href={safe}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-primary underline underline-offset-2"
              >
                {children}
              </a>
            ) : (
              <span>{children}</span>
            );
          },
          img: ({ src, alt }) => (typeof src === 'string' && src.startsWith('https://') ? (
            <img src={src} alt={alt || ''} className="max-h-64 rounded-md border border-border" loading="lazy" />
          ) : null),
          p: ({ children }) => <p className="whitespace-pre-wrap">{children}</p>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
